import { APP_ROUTES, useAppTranslation } from "@/utils";
import { CloseCircleFilled } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";
import { Link } from "react-router";

const InstallmentVerifyCallbackFailedPage = () => {
  const { t } = useAppTranslation();

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center" justify="center">
      <Flex vertical align="center" justify="center" gap={"large"} className="tw:my-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />

        <Flex vertical gap={"small"} align="center" justify="center">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {t("pay.installmentVerifyCallback.paymentRejectTitle")}
          </Typography.Title>
          <Typography.Text type="secondary" className="tw:text-center">
            {t("pay.installmentVerifyCallback.paymentRejectContent")}
          </Typography.Text>
        </Flex>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Link className="tw:w-full" to={APP_ROUTES.home.overview.url}>
          <Button block type="primary">
            {t("common.returnToHome")}
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};

export default InstallmentVerifyCallbackFailedPage;
